import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import ProjectList from '@app/views/Project/List';
import { memo } from 'react';

export default memo(
  withIfUser(ProjectList)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
